import { defineMessages } from 'react-intl';

export default defineMessages({
  scheduleTableTradeShiftTitle: {
    id: 'scheduleTable.tradeShift.title',
    defaultMessage: 'Wymiana zmiany',
  },
});
